import { connect } from 'react-redux';
import PurchaseImage from '../../../containers/purchase-image.container';
import {
  hasImageVersion,
  extractImage,
  ORIGINAL,
  FULL_FOUR_THIRD
} from '../../lib/image-versions';

const mapStateToProps = ({ purchases }, ownProps) => {
  const purchase = purchases.byId[purchases.current];
  const { product } = purchase;
  const defaultImageUrl = getDefaultImage(purchase);

  return {
    version: FULL_FOUR_THIRD,
    alt: product.name,
    images: product.images,
    defaultImageUrl,
  };
};

const getDefaultImage = ({ product: { images, defaultImageUrl } }) => {
  if (!images || !images.length) return defaultImageUrl;
  if (!hasImageVersion(images, FULL_FOUR_THIRD)) return extractImage(images, ORIGINAL);
}

export default connect(mapStateToProps)(PurchaseImage);




// WEBPACK FOOTER //
// ./src/desktop/containers/purchase-dashboard/purchase-image-magnifier.container.js